import { useContext } from "react";
import AuthContext from "../contexts/AuthContext";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
// eslint-disable-next-line
import { isAdminEmail } from "../consts/user";
import { hasAdminPermission } from "../utils/auth";

export const ProtectedRoute = ({ children }) => {
  const { user, authTokens, isRefreshing } = useContext(AuthContext);
  const { t } = useTranslation();

  // eslint-disable-next-line
  const isStoreRoute = window.location.pathname.includes("/store");
  const isWarehouseRoute = window.location.pathname.includes("/v2/warehouse");

  // If we're refreshing tokens, show a loading state instead of redirecting
  if (isRefreshing && !user) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">{t("common.loading")}</p>
        </div>
      </div>
    );
  }

  if (!user) {
    const currentUrl = `${window.location.pathname}${window.location.search}`;
    return (
      <Navigate
        to={`${t("urls.login")}?redirectTo=${encodeURIComponent(currentUrl)}`}
      />
    );
  }

  // Check permissions for warehouse route
  if (isWarehouseRoute) {
    const isAdminUser = hasAdminPermission(authTokens?.access_token);

    if (!isAdminUser) {
      return <Navigate to="/" />;
    }
  }

  // Keep email domain check for store routes for backward compatibility
  if (isStoreRoute && !isAdminEmail(user.email)) {
    return <Navigate to="/" />;
  }

  return children;
};
